import axios from 'axios'
import Qs from 'qs'
import utils from './utils'

const serviceStatusUrl = '/api/serviceStatus'
const tokenListUrl = '/api/getTokenList'
const getDepositInfotUrl = '/api/getDepositInfo'
const swapUrl = '/api/startSwap'
const swapTransactionsUrl = '/api/swap/transactions'
const successCode = 200
const internalServerError = 600

function newWebServiceResponse () {
  return {
    res: null,
    errCode: null,
    errMsg: null
  }
}

function parseResponseFromAxiosError (error) {
  let response = newWebServiceResponse()
  if (error.message.includes('timeout')) {
    response.errMsg = error
  } else {
    if (utils.checkIsNotNullObj(error.response)) {
      let res = error.response
      response.errCode = res.status
      response.errMsg = res.data || res.statusText
    } else {
      response.errMsg = error.message
    }
  }
  return response
}

/**
 * format post params when request
 * @param data: params object
 */
function formatPostParams (data) {
  return Qs.stringify(data)
}

/**
 * Common request wrapper — eliminates repeated try/await/catch boilerplate.
 * @param {Function} requestFn - returns an axios promise
 * @param {Function} extractFn - (responseData, result) => result  — maps response to result
 */
async function safeRequest (requestFn, extractFn) {
  let result = newWebServiceResponse()
  let response
  try {
    response = await requestFn()
  } catch (error) {
    return parseResponseFromAxiosError(error)
  }
  try {
    return extractFn(response.data, result)
  } catch (e) {
    console.error('safeRequest extractFn error:', e)
    result.errMsg = e.message || e
    return result
  }
}

export default {
  async isServiceAvailable () {
    return safeRequest(
      () => axios.get(serviceStatusUrl),
      (data, result) => { result.res = data.status; return result }
    )
  },

  async getSwapTokenList () {
    return safeRequest(
      () => axios.get(tokenListUrl),
      (data, result) => { result.res = data.List; return result }
    )
  },

  async getDepositInfo (swapType, swapAddress, exChangeMemo) {
    const p = formatPostParams({ swapType, address: swapAddress, memo: exChangeMemo })
    return safeRequest(
      () => axios.post(getDepositInfotUrl, p),
      (data, result) => {
        const status = data[utils.statusKey]
        if (status === undefined) {
          result.errCode = internalServerError
          result.errMsg = 'unknown error'
        } else if (status === successCode) {
          result.res = data[utils.infoKey] || null
        } else {
          result.errCode = status
          result.errMsg = data[utils.msgKey] || ''
        }
        return result
      }
    )
  },

  async startSwap (swapType, swapAddress) {
    const p = formatPostParams({ swapType, address: swapAddress })
    return safeRequest(
      () => axios.post(swapUrl, p),
      (data, result) => { result.res = data.List; return result }
    )
  },

  /**
   * get swap transaction list (for status page)
   * @param sourceToken: 'bep20' | 'erc20' | 'cos'
   * @param until: cursor timestamp, omit for page 1
   * @param page: page number (default 1)
   * @param limit: items per page (default 10)
   */
  async getSwapTransactions (sourceToken, { until, page = 1, limit = 10 } = {}) {
    return safeRequest(
      () => axios.get(swapTransactionsUrl, {
        params: {
          source_token: sourceToken,
          limit,
          ...(until ? { until, page } : {})
        }
      }),
      (data, result) => {
        if (data.code === 0 && data.data) {
          result.res = data.data
        } else {
          result.errCode = data.code
          result.errMsg = data.message || 'unknown error'
        }
        return result
      }
    )
  }
}
